'use es6';

export const APP_STARTED = 'APP_STARTED';
export const INITIALIZED_HEADER_DETAILS_SIDEBAR = 'INITIALIZED_HEADER_DETAILS_SIDEBAR';
export const NAVIGATED_TO_PAGE = 'NAVIGATED_TO_PAGE';
export const RECEIVED_CONTENT = 'RECEIVED_CONTENT';
export const REQUESTED_CONTENT = 'REQUESTED_CONTENT';
export const REQUESTED_CONTENT_FAILED = 'REQUESTED_CONTENT_FAILED';
export const REQUESTED_UPDATE_CONTENT = 'REQUESTED_UPDATE_CONTENT';
export const REQUESTED_UPDATE_CONTENT_FAILED = 'REQUESTED_UPDATE_CONTENT_FAILED';
export const REQUESTED_UPDATE_CONTENT_SUCCEEDED = 'REQUESTED_UPDATE_CONTENT_SUCCEEDED';
export const REQUESTED_ARCHIVE_CONTENT = 'REQUESTED_ARCHIVE_CONTENT';
export const REQUESTED_ARCHIVE_CONTENT_FAILED = 'REQUESTED_ARCHIVE_CONTENT_FAILED';
export const REQUESTED_ARCHIVE_CONTENT_SUCCEEDED = 'REQUESTED_ARCHIVE_CONTENT_SUCCEEDED';
export const REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT = 'REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT';
export const REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_FAILED = 'REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_FAILED';
export const REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_SUCCEEDED = 'REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_SUCCEEDED';
export const REQUESTED_UNARCHIVE_CONTENT = 'REQUESTED_UNARCHIVE_CONTENT';
export const REQUESTED_UNARCHIVE_CONTENT_FAILED = 'REQUESTED_UNARCHIVE_CONTENT_FAILED';
export const REQUESTED_UNARCHIVE_CONTENT_SUCCEEDED = 'REQUESTED_UNARCHIVE_CONTENT_SUCCEEDED';
export const REQUESTED_UNPUBLISH_CONTENT = 'REQUESTED_UNPUBLISH_CONTENT';
export const REQUESTED_UNPUBLISH_CONTENT_FAILED = 'REQUESTED_UNPUBLISH_CONTENT_FAILED';
export const REQUESTED_UNPUBLISH_CONTENT_SUCCEEDED = 'REQUESTED_UNPUBLISH_CONTENT_SUCCEEDED';
export const REQUESTED_PUBLISH_CONTENT = 'REQUESTED_PUBLISH_CONTENT';
export const REQUESTED_PUBLISH_CONTENT_FAILED = 'REQUESTED_PUBLISH_CONTENT_FAILED';
export const REQUESTED_PUBLISH_CONTENT_SUCCEEDED = 'REQUESTED_PUBLISH_CONTENT_SUCCEEDED';
export const REQUESTED_CLONE_CONTENT = 'REQUESTED_CLONE_CONTENT';
export const REQUESTED_CLONE_CONTENT_FAILED = 'REQUESTED_CLONE_CONTENT_FAILED';
export const REQUESTED_CLONE_CONTENT_SUCCEEDED = 'REQUESTED_CLONE_CONTENT_SUCCEEDED';
export const REQUESTED_DELETE_CONTENT = 'REQUESTED_DELETE_CONTENT';
export const REQUESTED_DELETE_CONTENT_FAILED = 'REQUESTED_DELETE_CONTENT_FAILED';
export const REQUESTED_DELETE_CONTENT_SUCCEEDED = 'REQUESTED_DELETE_CONTENT_SUCCEEDED';
export const REQUESTED_CONVERT_CONTENT = 'REQUESTED_CONVERT_CONTENT';
export const REQUESTED_CONVERT_CONTENT_FAILED = 'REQUESTED_CONVERT_CONTENT_FAILED';
export const REQUESTED_CONVERT_CONTENT_SUCCEEDED = 'REQUESTED_CONVERT_CONTENT_SUCCEEDED';
export const REQUESTED_CHANGE_AUDIENCE_ACCESS = 'REQUESTED_CHANGE_AUDIENCE_ACCESS';
export const REQUESTED_CHANGE_AUDIENCE_ACCESS_FAILED = 'REQUESTED_CHANGE_AUDIENCE_ACCESS_FAILED';
export const REQUESTED_CHANGE_AUDIENCE_ACCESS_SUCCEEDED = 'REQUESTED_CHANGE_AUDIENCE_ACCESS_SUCCEEDED';
export const RECEIVED_FORMS = 'RECEIVED_FORMS';
export const REQUESTED_FORMS = 'REQUESTED_FORMS';
export const REQUESTED_FORMS_FAILED = 'REQUESTED_FORMS_FAILED';
export const RECEIVED_STYLESHEETS = 'RECEIVED_STYLESHEETS';
export const REQUESTED_STYLESHEETS = 'REQUESTED_STYLESHEETS';
export const REQUESTED_STYLESHEETS_FAILED = 'REQUESTED_STYLESHEETS_FAILED';
export const RECEIVED_TEMPLATE = 'RECEIVED_TEMPLATE';
export const REQUESTED_TEMPLATE = 'REQUESTED_TEMPLATE';
export const REQUESTED_TEMPLATE_FAILED = 'REQUESTED_TEMPLATE_FAILED';
export const UPDATED_CONTENT_TITLE = 'UPDATED_CONTENT_TITLE';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_SOCIAL_COMPOSER = 'OPEN_SOCIAL_COMPOSER';
export const CLOSE_SOCIAL_COMPOSER = 'CLOSE_SOCIAL_COMPOSER';
export const UPDATE_SOCIAL_COMPOSER_PARAMS = 'UPDATE_SOCIAL_COMPOSER_PARAMS';
export const ARCHIVED_CONTENT = 'ARCHIVED_CONTENT';
export const ARCHIVED_AND_UNPUBLISHED_CONTENT = 'ARCHIVED_AND_UNPUBLISHED_CONTENT';
export const UNARCHIVED_CONTENT = 'UNARCHIVED_CONTENT';
export const UNPUBLISHED_CONTENT = 'UNPUBLISHED_CONTENT';
export const PUBLISHED_CONTENT = 'PUBLISHED_CONTENT';
export const CLONED_CONTENT = 'CLONED_CONTENT';
export const DELETED_CONTENT = 'DELETED_CONTENT';
export const CONVERTED_CONTENT = 'CONVERTED_CONTENT';
export const CHANGED_CONTENT_AUDIENCE_ACCESS = 'CHANGED_CONTENT_AUDIENCE_ACCESS';
export const OPEN_ADS_PANEL = 'OPEN_ADS_PANEL';
export const CLOSE_ADS_PANEL = 'CLOSE_ADS_PANEL';
export const RECEIVED_VARIATIONS = 'RECEIVED_VARIATIONS';
export const REQUESTED_VARIATIONS = 'REQUESTED_VARIATIONS';
export const REQUESTED_VARIATIONS_FAILED = 'REQUESTED_VARIATIONS_FAILED';
export const CHOSE_VARIATION_WINNER = 'CHOSE_VARIATION_WINNER';
export const REQUESTED_CHOOSE_VARIATION_WINNER = 'REQUESTED_CHOOSE_VARIATION_WINNER';
export const REQUESTED_CHOOSE_VARIATION_WINNER_FAILED = 'REQUESTED_CHOOSE_VARIATION_WINNER_FAILED';
export const REQUESTED_CHOOSE_VARIATION_WINNER_SUCCEEDED = 'REQUESTED_CHOOSE_VARIATION_WINNER_SUCCEEDED';
export const RERAN_VARIATION = 'RERAN_VARIATION';
export const REQUESTED_RERUN_VARIATION = 'REQUESTED_RERUN_VARIATION';
export const REQUESTED_RERUN_VARIATION_FAILED = 'REQUESTED_RERUN_VARIATION_FAILED';
export const REQUESTED_RERUN_VARIATION_SUCCEEDED = 'REQUESTED_RERUN_VARIATION_SUCCEEDED';
export const CREATED_VARIATION = 'CREATED_VARIATION';
export const REQUESTED_CREATED_VARIATION = 'REQUESTED_CREATED_VARIATION';
export const REQUESTED_CREATED_VARIATION_FAILED = 'REQUESTED_CREATED_VARIATION_FAILED';
export const REQUESTED_CREATED_VARIATION_SUCCEEDED = 'REQUESTED_CREATED_VARIATION_SUCCEEDED';
export const RECEIVED_HUBDB_TABLE = 'RECEIVED_HUBDB_TABLE';
export const REQUESTED_HUBDB_TABLE = 'REQUESTED_HUBDB_TABLE';
export const REQUESTED_HUBDB_TABLE_FAILED = 'REQUESTED_HUBDB_TABLE_FAILED';
export const RECEIVED_HUBDB_ROWS = 'RECEIVED_HUBDB_ROWS';
export const REQUESTED_HUBDB_ROWS = 'REQUESTED_HUBDB_ROWS';
export const REQUESTED_HUBDB_ROWS_FAILED = 'REQUESTED_HUBDB_ROWS_FAILED';
export const RECEIVED_LANGUAGES = 'RECEIVED_LANGUAGES';
export const REQUESTED_LANGUAGES = 'REQUESTED_LANGUAGES';
export const REQUESTED_LANGUAGES_FAILED = 'REQUESTED_LANGUAGES_FAILED';
export const RECEIVED_SETTINGS = 'RECEIVED_SETTINGS';
export const REQUESTED_SETTINGS = 'REQUESTED_SETTINGS';
export const REQUESTED_SETTINGS_FAILED = 'REQUESTED_SETTINGS_FAILED';
export const CREATED_TRANSLATION_VARIATION = 'CREATED_TRANSLATION_VARIATION';
export const CREATED_BLOG_POST_TRANSLATION_VARIATION = 'CREATED_BLOG_POST_TRANSLATION_VARIATION';
export const REQUESTED_CREATE_TRANSLATION_VARIATION = 'REQUESTED_CREATE_TRANSLATION_VARIATION';
export const REQUESTED_CREATE_TRANSLATION_VARIATION_FAILED = 'REQUESTED_CREATE_TRANSLATION_VARIATION_FAILED';
export const REQUESTED_CREATE_TRANSLATION_VARIATION_SUCCEEDED = 'REQUESTED_CREATE_TRANSLATION_VARIATION_SUCCEEDED';
export const ATTACHED_TO_LANGUAGE_MASTER = 'ATTACHED_TO_LANGUAGE_MASTER';
export const REMOVE_FROM_LANGUAGE_GROUP = 'REMOVE_FROM_LANGUAGE_GROUP';
export const REQUESTED_ATTACH_TO_LANGUAGE_MASTER = 'REQUESTED_ATTACH_TO_LANGUAGE_MASTER';
export const REQUESTED_ATTACH_TO_LANGUAGE_MASTER_FAILED = 'REQUESTED_ATTACH_TO_LANGUAGE_MASTER_FAILED';
export const REQUESTED_ATTACH_TO_LANGUAGE_MASTER_SUCCEEDED = 'REQUESTED_ATTACH_TO_LANGUAGE_MASTER_SUCCEEDED';
export const FETCHED_SETTINGS = 'FETCHED_SETTINGS';
export const NAVIGATED_TO_EXTERNAL_PAGE = 'NAVIGATED_TO_EXTERNAL_PAGE';
export const FETCHED_LISTS = 'FETCHED_LISTS';
export const RECEIVED_LISTS = 'RECEIVED_LISTS';
export const REQUESTED_LISTS = 'REQUESTED_LISTS';
export const REQUESTED_LISTS_FAILED = 'REQUESTED_LISTS_FAILED';
export const FETCHED_SPECIFIC_LISTS = 'FETCHED_SPECIFIC_LISTS';
export const RECEIVED_SPECIFIC_LISTS = 'RECEIVED_SPECIFIC_LISTS';
export const REQUESTED_SPECIFIC_LISTS = 'REQUESTED_SPECIFIC_LISTS';
export const REQUESTED_SPECIFIC_LISTS_FAILED = 'REQUESTED_SPECIFIC_LISTS_FAILED';
export const FETCHED_LIST_REGISTRATIONS = 'FETCHED_LIST_REGISTRATIONS';
export const RECEIVED_LIST_REGISTRATIONS = 'RECEIVED_LIST_REGISTRATIONS';
export const REQUESTED_LIST_REGISTRATIONS = 'REQUESTED_LIST_REGISTRATIONS';
export const REQUESTED_LIST_REGISTRATIONS_FAILED = 'REQUESTED_LIST_REGISTRATIONS_FAILED';
export const FETCHED_STATIC_LISTS = 'FETCHED_STATIC_LISTS';
export const RECEIVED_STATIC_LISTS = 'RECEIVED_STATIC_LISTS';
export const REQUESTED_STATIC_LISTS = 'REQUESTED_STATIC_LISTS';
export const REQUESTED_STATIC_LISTS_FAILED = 'REQUESTED_STATIC_LISTS_FAILED';
export const USED_IN_LIST = 'USED_IN_LIST';
export const REQUESTED_USE_IN_LIST = 'REQUESTED_USE_IN_LIST';
export const REQUESTED_USE_IN_LIST_FAILED = 'REQUESTED_USE_IN_LIST_FAILED';
export const REQUESTED_USE_IN_LIST_SUCCEEDED = 'REQUESTED_USE_IN_LIST_SUCCEEDED';
export const CREATED_AND_USED_IN_LIST = 'CREATED_AND_USED_IN_LIST';
export const REQUESTED_CREATE_AND_USE_IN_LIST = 'REQUESTED_CREATE_AND_USE_IN_LIST';
export const REQUESTED_CREATE_AND_USE_IN_LIST_FAILED = 'REQUESTED_CREATE_AND_USE_IN_LIST_FAILED';
export const REQUESTED_CREATE_AND_USE_IN_LIST_SUCCEEDED = 'REQUESTED_CREATE_AND_USE_IN_LIST_SUCCEEDED';
export const REQUESTED_SMART_CONTENT = 'REQUESTED_SMART_CONTENT';
export const REQUESTED_SMART_CONTENT_FAILED = 'REQUESTED_SMART_CONTENT_FAILED';
export const REQUESTED_SMART_CONTENT_SUCCEEDED = 'REQUESTED_SMART_CONTENT_SUCCEEDED';
export const UPDATE_LISTS_FOR_CONTENT = 'UPDATE_LISTS_FOR_CONTENT';
export const RECEIVED_MAB = 'RECEIVED_MAB';
export const REQUESTED_MAB = 'REQUESTED_MAB';
export const REQUESTED_MAB_FAILED = 'REQUESTED_MAB_FAILED';
export const REQUESTED_MAB_END_EXPERIMENT = 'REQUESTED_MAB_END_EXPERIMENT';
export const REQUESTED_MAB_END_EXPERIMENT_FAILED = 'REQUESTED_MAB_END_EXPERIMENT_FAILED';
export const REQUESTED_MAB_END_EXPERIMENT_SUCCEEDED = 'REQUESTED_MAB_END_EXPERIMENT_SUCCEEDED';
export const REQUESTED_MAB_PAST_EXPERIMENTS = 'REQUESTED_MAB_PAST_EXPERIMENTS';
export const REQUESTED_MAB_PAST_EXPERIMENTS_FAILED = 'REQUESTED_MAB_PAST_EXPERIMENTS_FAILED';
export const REQUESTED_MAB_PAST_EXPERIMENTS_SUCCEEDED = 'REQUESTED_MAB_PAST_EXPERIMENTS_SUCCEEDED';
export const FETCHED_VIDEO_MAP = 'FETCHED_VIDEO_MAP';
export const RECEIVED_VIDEO_MAP = 'RECEIVED_VIDEO_MAP';
export const REQUESTED_VIDEO_MAP = 'REQUESTED_VIDEO_MAP';
export const REQUESTED_VIDEO_MAP_FAILED = 'REQUESTED_VIDEO_MAP_FAILED';
export const REQUESTED_PERFORMANCE_DATA_CHECK = 'REQUESTED_PERFORMANCE_DATA_CHECK';
export const REQUESTED_PERFORMANCE_DATA_CHECK_FAILED = 'REQUESTED_PERFORMANCE_DATA_CHECK_FAILED';
export const RECIEVED_PERFORMANCE_DATA_CHECK = 'RECIEVED_PERFORMANCE_DATA_CHECK';
export const FETCH_SMART_CONTENT_DATA_CHECK = 'FETCH_SMART_CONTENT_DATA_CHECK';
export const REQUESTED_SMART_CONTENT_DATA_CHECK = 'REQUESTED_SMART_CONTENT_DATA_CHECK';
export const REQUESTED_SMART_CONTENT_DATA_CHECK_FAILED = 'REQUESTED_SMART_CONTENT_DATA_CHECK_FAILED';
export const RECIEVED_SMART_CONTENT_DATA_CHECK = 'RECIEVED_SMART_CONTENT_DATA_CHECK';
export const FETCHED_ADS_DATA = 'FETCHED_ADS_DATA';
export const RECEIVED_ADS_DATA = 'RECEIVED_ADS_DATA';
export const REQUESTED_ADS_DATA = 'REQUESTED_ADS_DATA';
export const REQUESTED_ADS_DATA_FAILED = 'REQUESTED_ADS_DATA_FAILED';
export const REQUESTED_BLOG_USAGE_LIMITS = 'REQUESTED_BLOG_USAGE_LIMITS';
export const RECEIVED_BLOG_USAGE_LIMITS = 'RECEIVED_BLOG_USAGE_LIMITS';
export const REQUESTED_BLOG_USAGE_LIMITS_FAILED = 'REQUESTED_BLOG_USAGE_LIMITS_FAILED';
export const REQUESTED_CONTENT_USAGE_LIMITS = 'REQUESTED_CONTENT_USAGE_LIMITS';
export const RECEIVED_CONTENT_USAGE_LIMITS = 'RECEIVED_CONTENT_USAGE_LIMITS';
export const REQUESTED_CONTENT_USAGE_LIMITS_FAILED = 'REQUESTED_CONTENT_USAGE_LIMITS_FAILED';
export const REQUESTED_ADVANCED_LP_SCOPE_CHANGE = 'REQUESTED_ADVANCED_LP_SCOPE_CHANGE';
export const RECEIVED_ADVANCED_LP_SCOPE_CHANGE = 'RECEIVED_ADVANCED_LP_SCOPE_CHANGE';
export const REQUESTED_ADVANCED_LP_SCOPE_CHANGE_FAILED = 'REQUESTED_ADVANCED_LP_SCOPE_CHANGE_FAILED';
export const FETCHED_DOMAIN = 'FETCHED_DOMAIN';
export const REQUESTED_DOMAIN = 'REQUESTED_DOMAIN';
export const RECEIVED_DOMAIN = 'RECEIVED_DOMAIN';
export const REQUESTED_DOMAIN_FAILED = 'REQUESTED_DOMAIN_FAILED';
export const REQUESTED_CUSTOM_DOMAINS_PURGE_DATE = 'REQUESTED_CUSTOM_DOMAINS_PURGE_DATE';
export const RECEIVED_CUSTOM_DOMAINS_PURGE_DATE = 'RECEIVED_CUSTOM_DOMAINS_PURGE_DATE';
export const REQUESTED_CUSTOM_DOMAINS_PURGE_DATE_FAILED = 'REQUESTED_CUSTOM_DOMAINS_PURGE_DATE_FAILED';
export const REQUESTED_AUDIENCE_ACCESS_PURGE_DATE = 'REQUESTED_AUDIENCE_ACCESS_PURGE_DATE';
export const RECEIVED_AUDIENCE_ACCESS_PURGE_DATE = 'RECEIVED_AUDIENCE_ACCESS_PURGE_DATE';
export const REQUESTED_AUDIENCE_ACCESS_PURGE_DATE_FAILED = 'REQUESTED_AUDIENCE_ACCESS_PURGE_DATE_FAILED';
export const REQUESTED_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE = 'REQUESTED_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE';
export const RECEIVED_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE = 'RECEIVED_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE';
export const REQUESTED_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED = 'REQUESTED_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED';
export const REQUESTED_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE = 'REQUESTED_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE';
export const RECEIVED_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE = 'RECEIVED_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE';
export const REQUESTED_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED = 'REQUESTED_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED';
export const REQUESTED_HUBDB_CUSTOM_DOMAIN_PURGE_DATE = 'REQUESTED_HUBDB_CUSTOM_DOMAIN_PURGE_DATE';
export const RECEIVED_HUBDB_CUSTOM_DOMAIN_PURGE_DATE = 'RECEIVED_HUBDB_CUSTOM_DOMAIN_PURGE_DATE';
export const REQUESTED_HUBDB_CUSTOM_DOMAIN_PURGE_DATE_FAILED = 'REQUESTED_HUBDB_CUSTOM_DOMAIN_PURGE_DATE_FAILED';
export const REQUESTED_USER_ATTRIBUTES = 'REQUESTED_USER_ATTRIBUTES';
export const RECEIVED_USER_ATTRIBUTES = 'RECEIVED_USER_ATTRIBUTES';
export const REQUESTED_USER_ATTRIBUTES_FAILED = 'REQUESTED_USER_ATTRIBUTES_FAILED';
export const REQUEST_SET_ATTRIBUTE = 'REQUEST_SET_ATTRIBUTE';
export const REQUESTED_SET_ATTRIBUTE_FAILURE = 'REQUESTED_SET_ATTRIBUTE_FAILURE';
export const REQUESTED_SET_ATTRIBUTE_SUCCESS = 'REQUESTED_SET_ATTRIBUTE_SUCCESS';
export const FINISH_FREE_LP_ONBOARDING_TOUR = 'FINISH_FREE_LP_ONBOARDING_TOUR';
export const REQUESTED_REMOVE_FROM_LANGUAGE_GROUP = 'REQUESTED_REMOVE_FROM_LANGUAGE_GROUP';
export const REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_FAILED = 'REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_FAILED';
export const REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_SUCCEEDED = 'REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_SUCCEEDED';
export const RECEIVED_CRM_OBJECTS = 'RECEIVED_CRM_OBJECTS';
export const REQUESTED_CRM_OBJECTS = 'REQUESTED_CRM_OBJECTS';
export const REQUESTED_CRM_OBJECTS_FAILED = 'REQUESTED_CRM_OBJECTS_FAILED';
export const RECEIVED_CRM_OBJECT_ID = 'RECEIVED_CRM_OBJECT_ID';
export const REQUESTED_CMS_USER_SETTINGS = 'REQUESTED_CMS_USER_SETTINGS';
export const RECEIVED_CMS_USER_SETTINGS = 'RECEIVED_CMS_USER_SETTINGS';
export const REQUESTED_CMS_USER_SETTINGS_FAILED = 'REQUESTED_CMS_USER_SETTINGS_FAILED';